import { useState } from 'react';
import { ArrowUpRight, ChevronDown, Waves } from 'lucide-react';
import { getTriviaForPageLoad, remembersTrivia, rememberTrivia } from '../lib/trivia';

export function TriviaPanel() {
  const [story] = useState(getTriviaForPageLoad);
  const [remember, setRemember] = useState(remembersTrivia);
  if (!story) return null;

  return <section className="trivia-panel" aria-labelledby="trivia-heading" data-trivia-id={story.id}>
    <div className="trivia-intro">
      <Waves size={28} strokeWidth={1.5} aria-hidden="true" />
      <h2 id="trivia-heading">Morskie zaskoczenia</h2>
      <p>Chwila ciekawości przed rejsem.</p>
    </div>
    <article className="trivia-story">
      <h3>{story.title}</h3>
      <p className="trivia-lead">{story.lead}</p>
      <details className="trivia-details">
        <summary>Poznaj całą historię <ChevronDown size={17} aria-hidden="true" /></summary>
        <div className="trivia-expanded">
          <p>{story.details}</p>
          <ul className="trivia-sources" aria-label="Źródła ciekawostki">
            {story.sources.map((source) => <li key={source.url}>
              <a className="inline-link" href={source.url} target="_blank" rel="noopener noreferrer">
                Poznaj źródło <ArrowUpRight size={16} aria-hidden="true" />
                <span className="sr-only">: {source.name} (otwiera się w nowej karcie)</span>
              </a>
              <span className="trivia-source-name">{source.name}</span>
            </li>)}
          </ul>
        </div>
      </details>
      <label className="check"><input type="checkbox" checked={remember} onChange={event => setRemember(rememberTrivia(event.target.checked))} /> Zapamiętuj przeczytane ciekawostki na tym urządzeniu</label>
    </article>
  </section>;
}
